var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.5011L43.75 12.5026M16.6667 25.0011L43.75 25.0028M16.6667 37.5011L43.75 37.5028M7.29167 12.4997H7.3125M7.29167 24.9997H7.3125M7.29167 37.4997H7.3125M8.33333 12.4997C8.33333 13.075 7.86696 13.5413 7.29167 13.5413C6.71637 13.5413 6.25 13.075 6.25 12.4997C6.25 11.9244 6.71637 11.458 7.29167 11.458C7.86696 11.458 8.33333 11.9244 8.33333 12.4997ZM8.33333 24.9997C8.33333 25.5749 7.86696 26.0413 7.29167 26.0413C6.71637 26.0413 6.25 25.5749 6.25 24.9997C6.25 24.4245 6.71637 23.958 7.29167 23.958C7.86696 23.958 8.33333 24.4245 8.33333 24.9997ZM8.33333 37.4997C8.33333 38.0749 7.86696 38.5413 7.29167 38.5413C6.71637 38.5413 6.25 38.0749 6.25 37.4997C6.25 36.9245 6.71637 36.458 7.29167 36.458C7.86696 36.458 8.33333 36.9245 8.33333 37.4997Z",
    stroke: "#B7C1C8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "dots",
    d: "M7.29167 12.4997H7.3125M7.29167 24.9997H7.3125M7.29167 37.4997H7.3125M8.33333 12.4997C8.33333 13.075 7.86696 13.5413 7.29167 13.5413C6.71637 13.5413 6.25 13.075 6.25 12.4997C6.25 11.9244 6.71637 11.458 7.29167 11.458C7.86696 11.458 8.33333 11.9244 8.33333 12.4997ZM8.33333 24.9997C8.33333 25.5749 7.86696 26.0413 7.29167 26.0413C6.71637 26.0413 6.25 25.5749 6.25 24.9997C6.25 24.4245 6.71637 23.958 7.29167 23.958C7.86696 23.958 8.33333 24.4245 8.33333 24.9997ZM8.33333 37.4997C8.33333 38.0749 7.86696 38.5413 7.29167 38.5413C6.71637 38.5413 6.25 38.0749 6.25 37.4997C6.25 36.9245 6.71637 36.458 7.29167 36.458C7.86696 36.458 8.33333 36.9245 8.33333 37.4997Z",
    stroke: "#8BC144",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDataIcon);
export default __webpack_public_path__ + "static/media/empty-data-icon.f60e3db3f82124d72f361a1b9715f7e4.svg";
export { ForwardRef as ReactComponent };